import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-46326a26"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "manageable-list-wrapper" };
const _hoisted_2 = {
    key: 0,
    class: "custom-schedule-duration__trigger"
};
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "far fa-plus" }, null, -1 /* HOISTED */));
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-chevron-down" }, null, -1 /* HOISTED */));
const _hoisted_5 = {
    key: 1,
    class: "custom-schedule-duration-form"
};
const _hoisted_6 = { key: 0 };
const _hoisted_7 = {
    key: 1,
    class: "dropdown-prompt"
};
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fal fa-check" }, null, -1 /* HOISTED */));
const _hoisted_9 = [
    _hoisted_8
];
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fal fa-times" }, null, -1 /* HOISTED */));
const _hoisted_11 = [
    _hoisted_10
];
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
    key: 2,
    class: "toggler-wrapper"
};
const _hoisted_14 = {
    key: 0,
    class: "fal fa-chevron-up"
};
const _hoisted_15 = {
    key: 1,
    class: "fal fa-chevron-down"
};
import { ref, watch, nextTick, computed, reactive } from "vue";
import Button from "src/shared/v-components/ui/Button.vue";
import { removeTag } from "src/shared/Tags";
import { ElDropdown, ElDropdownItem, ElDropdownMenu } from "element-plus";
import { DEFAULT_OPTIONS, options, formattedIsoPeriod, convertMillisToIsoDuration, isoDurationToMillis, } from "src/shared/v-components/campaign-component-variable/input/schedule/schedule-duration-service";
import { useFocus } from "@vueuse/core";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ScheduleDurationList',
    props: {
        scheduleList: {},
        readonly: { type: Boolean, default: false },
        isFocused: { type: Boolean, default: false },
        placeholder: { default: "Add Custom Delay" }
    },
    emits: ["update:scheduleList", "update:isFocused", "update:tagInput"],
    setup(__props, { emit: __emit }) {
        const inputValue = ref("");
        const state = reactive({
            periodValue: 0,
        });
        const target = ref(null);
        const showMore = ref(false);
        const props = __props;
        const emit = __emit;
        const isAddShown = ref(false);
        const schedulesProxy = computed({
            get() {
                return props.scheduleList;
            },
            set(newValue) {
                const isoDurations = newValue
                    .map((element) => {
                    if (typeof element === "string") {
                        return element;
                    }
                    return convertMillisToIsoDuration(element);
                })
                    .filter((value) => value !== null);
                emit("update:scheduleList", isoDurations);
            },
        });
        const inputValueProxy = computed({
            get: () => {
                return inputValue.value;
            },
            set: (value) => {
                if (value === "") {
                    inputValue.value = "";
                }
                else {
                    const integerValue = parseInt(value);
                    inputValue.value = String(integerValue);
                }
            },
        });
        const remove = (tag) => {
            focused.value = true;
            nextTick(() => {
                const cloned = [...props.scheduleList];
                removeTag(cloned, tag);
                schedulesProxy.value = cloned;
            });
        };
        const { focused } = useFocus(target, {
            initialValue: props.isFocused,
        });
        watch(focused, (newValue, oldValue) => {
            if (oldValue === true && newValue === false) {
                emit("update:isFocused", false);
            }
            if (oldValue === false && newValue === true) {
                emit("update:isFocused", true);
            }
        });
        const handleInputConfirm = () => {
            if (inputValueProxy.value) {
                const cloned = [...props.scheduleList];
                if (state.periodValue > 0) {
                    cloned.push(convertMillisToIsoDuration(isoDurationToMillis(inputValueProxy.value) *
                        state.periodValue));
                }
                else {
                    cloned.push(inputValueProxy.value);
                }
                schedulesProxy.value = cloned;
            }
        };
        const addTimePeriod = () => {
            handleInputConfirm();
            cancelAdding();
        };
        const cancelAdding = () => {
            isAddShown.value = false;
            state.periodValue = 0;
            inputValue.value = "";
        };
        const setOption = (value) => {
            inputValue.value = value;
            addTimePeriod();
        };
        const setTimePeriod = (value) => {
            state.periodValue = +value;
        };
        const selectedOption = computed(() => {
            return options.find((option) => option.value === state.periodValue);
        });
        const displayedSchedules = computed(() => {
            var _a;
            return showMore.value
                ? schedulesProxy.value
                : ((_a = schedulesProxy.value) === null || _a === void 0 ? void 0 : _a.slice(0, 3)) || [];
        });
        const toggleShowMore = () => {
            showMore.value = !showMore.value;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (!isAddShown.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(Button, {
                            level: "tertiary",
                            class: "add-button",
                            onClick: _cache[0] || (_cache[0] = ($event) => (isAddShown.value = true))
                        }, {
                            default: _withCtx(() => [
                                _hoisted_3,
                                _createTextVNode(" " + _toDisplayString("Add Custom Delay"))
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_unref(ElDropdown), {
                            trigger: "click",
                            "popper-class": "list list--drop-down list--drop-down--modern"
                        }, {
                            dropdown: _withCtx(() => [
                                _createVNode(_unref(ElDropdownMenu), null, {
                                    default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(DEFAULT_OPTIONS), (option) => {
                                            return (_openBlock(), _createBlock(_unref(ElDropdownItem), {
                                                key: option.displayName,
                                                onClick: ($event) => (setOption(option.value))
                                            }, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("a", null, _toDisplayString(option.displayName), 1 /* TEXT */)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            default: _withCtx(() => [
                                _createVNode(Button, {
                                    shape: "square",
                                    level: "tertiary"
                                }, {
                                    default: _withCtx(() => [
                                        _hoisted_4
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]))
                    : _createCommentVNode("v-if", true),
                (isAddShown.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        (!_ctx.readonly)
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                ref_key: "target",
                                ref: target,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((inputValueProxy).value = $event))
                            }, null, 512 /* NEED_PATCH */)), [
                                [
                                    _vModelText,
                                    inputValueProxy.value,
                                    void 0,
                                    { number: true }
                                ]
                            ])
                            : _createCommentVNode("v-if", true),
                        _createVNode(_unref(ElDropdown), {
                            trigger: "click",
                            "popper-class": "list list--drop-down list--drop-down--modern"
                        }, {
                            dropdown: _withCtx(() => [
                                _createVNode(_unref(ElDropdownMenu), null, {
                                    default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(options), (option) => {
                                            return (_openBlock(), _createBlock(_unref(ElDropdownItem), {
                                                key: option.displayName,
                                                onClick: ($event) => (setTimePeriod(option.value))
                                            }, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("a", null, _toDisplayString(option.displayName), 1 /* TEXT */)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            default: _withCtx(() => [
                                _createVNode(Button, { level: "tertiary" }, {
                                    default: _withCtx(() => [
                                        (selectedOption.value)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(selectedOption.value.displayName), 1 /* TEXT */))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString("Time Format")))
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createElementVNode("div", { class: "invisible-button-wrapper" }, [
                            _createElementVNode("button", {
                                class: "button button--invisible",
                                type: "button",
                                onClick: addTimePeriod
                            }, _hoisted_9),
                            _createElementVNode("button", {
                                class: "button button--invisible",
                                type: "button",
                                onClick: cancelAdding
                            }, _hoisted_11)
                        ])
                    ]))
                    : _createCommentVNode("v-if", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedSchedules.value, (schedule) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: "manageable-list",
                        key: schedule
                    }, [
                        _createElementVNode("span", null, _toDisplayString(_unref(formattedIsoPeriod)(schedule)), 1 /* TEXT */),
                        (!_ctx.readonly)
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 0,
                                onClick: _withModifiers(($event) => (remove(schedule)), ["stop"]),
                                class: "fal fa-trash"
                            }, null, 8 /* PROPS */, _hoisted_12))
                            : _createCommentVNode("v-if", true)
                    ]));
                }), 128 /* KEYED_FRAGMENT */)),
                (schedulesProxy.value.length > 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("a", {
                            class: "show-more",
                            onClick: toggleShowMore
                        }, [
                            _createTextVNode(_toDisplayString(showMore.value ? "Show Less" : "Show More") + " ", 1 /* TEXT */),
                            (showMore.value)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_14))
                                : (_openBlock(), _createElementBlock("i", _hoisted_15))
                        ])
                    ]))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
